import { TextField } from '@mui/material';
import { useForm } from '@/common/form/FormContext';
import { DynamicFormField } from '@/common/form/formFields/DynamicFormField';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const EntityPropValue = ({ fieldDef }) => {

  const { formValues } = useForm();
  const module = useModuleFromRoute();
  const rsrc = useRsrc();
  const [propType, setPropType] = useState(null);
  const [propEnumValues, setPropEnumValues] = useState(null);

  const updatedFieldDef = {
    ...fieldDef
  }
  if (propType) {
    updatedFieldDef.type = propType;
    updatedFieldDef.values = propEnumValues;
  }

  useEffect(() => {
    if (!formValues.propId){
      setPropType(null);
      return;
    } 
    rsrc.data(module, 'ENTITY_PROP_VALUE_DATA_PLUGIN', { propId: formValues.propId }).then(res => {
      setPropType(res.type);
      setPropEnumValues(res.values);
    });
  }, [formValues.propId]);
  
  if (!propType) return  <TextField label={fieldDef.displayName} disabled={true}/>;

  return <DynamicFormField fieldDef={updatedFieldDef} />
}